<template>
  <v-layout
    :class="classes"
    :column="column"
    :row="row"
    wrap
    align-center
  >
    <v-flex v-if="toolbar">
      <v-toolbar
        class="secondary navbartext--text elevation-0"
        height="60"
      >
        <v-btn
          class="navbartext--text"
          icon
          @click="$store.commit('toggleSibebarExtraDrawer')"
        >
          <v-icon>close</v-icon>
        </v-btn>

        <v-toolbar-title>Buscador</v-toolbar-title>
      </v-toolbar>
    </v-flex>
    <v-flex mt-3 px-3 shrink>
      <v-select
        v-model="selectType"
        class="info--text body-2"
        color="info"
        background-color="transparent"
        flat
        label="Buscar por:"
        placeholder="Seleccione búsqueda"
        hide-details
        @change="getFunctions"
        :items="dataItems"
        item-value="id"
        item-text="name"
      ></v-select>
    </v-flex>
    <v-flex px-3>
      <v-text-field
        ref="textSearch"
        v-model="text"
        class="transparent info--text"
        flat
        placeholder="Buscar"
        :rules="[() => text.length >= searchMin || `Mínimo ${searchMin} caracteres`]"
        clearable
        @change="handleFunction"
      >
      </v-text-field>
    </v-flex>
    <v-flex px-3 mt-3>
      <v-btn
        color="success white--text"
        depressed
        @click="handleSearch"
        block
      >
        <v-icon>
          search
        </v-icon>
        Buscar
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex'
import { projectLimits } from '@/config'

export default {
  props: {
    row: {
      type: Boolean,
      default: false
    },
    column: {
      type: Boolean,
      default: false
    },
    classes: {
      type: String,
      default: ''
    },
    toolbar: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectType: null,
      text: null,
      sensitives: false
    }
  },
  methods: {
    handleSearch() {
      if (this.text != null && this.selectType) {
        this.$store.dispatch('listItems/changeOrder', {id: this.selectType})
      }
      if (!this.text || this.$refs.textSearch.validate()) {
        this.searching.searchFunction(true)
      }
    },
    getFunctions() {
      var typeConf = this.dataItems.filter((e) => {
        if (e.id == this.selectType) {
          return e
        }
      })
      this.sensitives = typeConf[0].sensitive ? typeConf[0].sensitive : false
      if (this.text) {
        this.handleFunction(this.text)
      }
    },
    handleFunction(e) {
      if (this.sensitives !== false) {
        this.text = this.sensitives(e)
      }
    }
  },
  computed: {
    ...mapState('listItems', ['orderColumns', 'searching']),
    dataItems() {
      return this.orderColumns.items
    },
    searchMin() {
      return projectLimits.searchMin
    }
  },
  watch: {
    selectType(newValue) {
      this.$store.commit('listItems/setSearching', {field: newValue, local: false})
      this.getFunctions()
    },
    text(newValue) {
      this.$store.commit('listItems/setSearching', {text: newValue, local: false})      
      if (newValue === null) {
        this.searching.searchFunction(true)
      }
    }
  },
  created() {
    this.selectType = this.searching.field
    this.text = this.searching.text    
  }
}
</script>

<style lang="scss">
.w-200 {
  width: 200px;
}
.h-37 {
  height: 37px;
  & > div {
    min-height: 37px !important;
  }
}
</style>
